module.exports = __webpack_public_path__ + "img/ROBOT_DT.cb1e800c.png";